import * as $ from 'jquery';
import * as _ from 'underscore';
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import {on, Options} from "../../utils/decorators";


@Options({
    template: false,
    el: ".js-nav-shared",
    ui: {
        hamburgerBtn: ".js-hamburger-btn",
        navMain: ".js-nav-primary-wrap",
        navLink: ".js-nav-link",
        navLogo: ".js-nav-logo",
        navPrimaryLink: ".js-nav-primary-wrap .js-nav-link",
    }
})

export default class NavMainViewController extends Marionette.View<Backbone.Model>{
    constructor() {
        super();
    }

    // -------------------------------------
    // constants
    // -------------------------------------

    // width at which nav swaps to desktop version
    static readonly NAV_SWAP_BREAKPOINT = 998;

    onRender() {
        console.log("nav main viewcontroller rendered");
        this.windowResizeCheck();

    }

    // -------------------------------------
    // mobile nav events
    // -------------------------------------

    // Hamburger / close btn toggles main nav on mobile
    // NOTE: due to pinned nav behavior, there are TWO
    // hamburger buttons.
    
    @on("click @ui.hamburgerBtn")
    onHamburgerBtnClick(JQueryEventObject) {
        JQueryEventObject.preventDefault();
        this.toggleMainNav();

        // Don't allow anything to scroll while nav is open
        $(document.body).toggleClass("overflow-hidden");
    }

    // -------------------------------------
    // desktop nav events
    // -------------------------------------

    // stub

    // ------------------------ //   
    // mobile nav functions
    // ------------------------ //

    toggleMainNav() {
        this.ui.navMain.toggleClass("active");
        // this.ui.navMobileDisplayWrap.toggleClass("show");
        this.ui.hamburgerBtn.toggleClass("switch-to-close-btn");
    }

    // ------------------------ //
    // desktop nav functions
    // ------------------------ //

    toggleNavStates($currentNavBtn) {
        let $primaryNavLinks = this.ui.navPrimaryLink;
        let $inactiveLinks = $primaryNavLinks.not($currentNavBtn);

        $inactiveLinks.toggleClass("fade-back");
    }

    // reset nav to default state
    clearAllNavStates() {
        this.ui.navLink.removeClass("active");
        this.ui.navLink.removeClass("fade-back");
    }

    windowResizeCheck() {
        // reach out to check window width:
        // close search overlay when resized down
        // since it should only be active on desktop
        $(window).resize( () => {
            if ( $(window).width() <= NavMainViewController.NAV_SWAP_BREAKPOINT) {
                // this.hideSearchOverlay();
            } else {
                // make sure page can scroll again on desktop width, in case
                // mobile nav was open and scroll blocked before resizing
                $(document.body).removeClass("overflow-hidden");
            }
        });
    }

    stopScrolling(JQueryEventObject) {
        JQueryEventObject.preventDefault();
        JQueryEventObject.stopPropagation();
        return false;
    }
}



// WEBPACK FOOTER //
// ./django/project/@static/@modules/shared/nav-main/controller.ts